// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ov-0";
export var leftAlign = "_ov-4";
export var listItem = "_ov-2";
export var listItemWrapper = "_ov-1";
export var operationText = "_ov-3";